<template>
  <transition name="fade">
    <button class="go-top" v-show="visible" @click="scrollTop" title="返回顶部">
      <i class="fas fa-chevron-up"></i>
    </button>
  </transition>
</template>

<script>
export default {
  name: 'GoTop',
  data() {
    return { visible: false }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.visible = window.scrollY > 400
    },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.go-top {
  position: fixed;
  right: 32px;
  bottom: 40px;
  z-index: 9999;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: linear-gradient(135deg, #007bff, #0056d2);
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
  /* 防止被父容器 overflow:hidden 裁切 */
  transform: translateZ(0);
}
.go-top:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(0, 123, 255, 0.5);
}
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue